var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#169560"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 67.9993,
    cy: 68.0003,
    r: 54.7317,
    fill: "#169560"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1433 33.0225C78.7317 33.0225 87.9273 36.8314 94.7074 43.6114C101.487 50.3915 105.296 59.5871 105.296 69.1755C105.296 78.7639 101.487 87.9596 94.7074 94.7396C87.9273 101.52 78.7317 105.329 69.1433 105.329C59.5549 105.329 50.3592 101.52 43.5792 94.7396C36.7992 87.9596 32.9902 78.7639 32.9902 69.1755C32.9902 59.5871 36.7992 50.3915 43.5792 43.6114C50.3592 36.8314 59.5549 33.0225 69.1433 33.0225ZM64.6397 76.308L56.6085 68.2717C56.3206 67.9838 55.9788 67.7554 55.6026 67.5996C55.2264 67.4438 54.8233 67.3636 54.4161 67.3636C54.0089 67.3636 53.6057 67.4438 53.2296 67.5996C52.8534 67.7554 52.5116 67.9838 52.2237 68.2717C51.6422 68.8532 51.3155 69.6418 51.3155 70.4641C51.3155 71.2864 51.6422 72.0751 52.2237 72.6565L62.4498 82.8827C62.7369 83.1721 63.0784 83.4017 63.4547 83.5585C63.831 83.7152 64.2346 83.7959 64.6422 83.7959C65.0499 83.7959 65.4535 83.7152 65.8297 83.5585C66.206 83.4017 66.5476 83.1721 66.8347 82.8827L88.01 61.7022C88.3018 61.4154 88.5339 61.0738 88.6929 60.6969C88.852 60.3201 88.9349 59.9154 88.9368 59.5064C88.9387 59.0973 88.8596 58.6919 88.704 58.3136C88.5485 57.9353 88.3196 57.5915 88.0305 57.302C87.7414 57.0126 87.3979 56.7833 87.0197 56.6273C86.6416 56.4713 86.2363 56.3917 85.8272 56.3931C85.4182 56.3946 85.0134 56.477 84.6364 56.6356C84.2593 56.7942 83.9174 57.0259 83.6303 57.3173L64.6397 76.308Z",
    fill: "#169560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSuccess);
export default __webpack_public_path__ + "static/media/feedback_success.54989ebea5a5d2377003b24b2c6b2b97.svg";
export { ForwardRef as ReactComponent };